// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      var blocks = doms(".block.cards");

      for (var index = 0; index < blocks.length; index++) {
        block.carousel.init(blocks[index]);
      }

    },

    /**
     * Object to handle carousel functionality.
     *
     * @property block.carousel
     */
    carousel: {

      /**
       * Method to handle carousel initialization.
       *
       * @method block.carousel.init
       */
      init: function(container) {

        this.index = 0;
        this.middle = 3;

        this.ui = {
          buttons: doms(".cards-navigation-wrapper-item-button", container),
          list: doms(".cards-carousel-item", container),
          title: dom(".cards-carousel-title", container),
          navigation: dom(".cards-navigation"),
        };

        if (this.ui.list.length > 1) {
          this.ui.navigation.classList.add("active");
        }

        for (var index = 0; index < this.ui.buttons.length; index++) {
          this.ui.buttons[index].onclick = this.click.bind(this);
        }

      },

      /**
       * Method to handle carousel on click.
       *
       * @method block.carousel.click
       */
      click: function(event) {

        var ui = this.ui;

        if (event.target.dataset.direction === "next") {
          if (this.index < ui.list.length - 1) {
            this.index += 1;
          } else {
            this.index = 0;
          }
        } else {
          if (this.index > 0) {
            this.index -= 1;
          } else {
            this.index = ui.list.length - 1;
          }
        }

        for (var index = 0; index < ui.list.length; index++) {

          var current = this.index + index;

          if (current >= ui.list.length) {
            current -= ui.list.length;
          }

          ui.list[index].dataset.index = current;

          if (current === this.middle) {
            ui.title.innerHTML = ui.list[index].getAttribute("aria-label");
          }

        }

      },

    },

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
